import { io } from "socket.io-client";

const SOCKET_URL = process.env.REACT_APP_SOCKET_URL;

console.log("🔌 SOCKET URL:", process.env.REACT_APP_SOCKET_URL);

export const socket = io(SOCKET_URL, {
    transports: ["websocket"],
    autoConnect: false, // IMPORTANT
});